var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "div" }, [
    _c("div", { staticClass: "main-container" }, [
      _c(
        "div",
        { staticClass: "left-panel" },
        [
          _c(
            "el-card",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.HomepageStatisticsLoading,
                  expression: "HomepageStatisticsLoading",
                },
              ],
              staticClass: "section-card device-overview",
              staticStyle: { height: "270px" },
            },
            [
              _c("div", { staticClass: "section-title" }, [_vm._v("设备总览")]),
              _c("div", { staticClass: "overview-content" }, [
                _c("div", { staticClass: "sales-card green-card" }, [
                  _c("div", { staticClass: "card-text" }, [
                    _c("div", { staticClass: "card-icon" }, [_vm._v("￥")]),
                    _vm._v(" LCC(设备全程期成本) "),
                  ]),
                  _c("div", { staticClass: "card-value" }, [
                    _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$tools.formatThousand(
                              _vm.HomepageStatisticsInfo.totalCost,
                              2
                            )
                          ) +
                          " "
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "card-growth" }, [
                    _c("div", [_vm._v("设备购置成本")]),
                    _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$tools.formatThousand(
                              _vm.HomepageStatisticsInfo.AcquisitionCost,
                              2
                            )
                          ) +
                          " "
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "card-footer" }),
                ]),
                _c("div", { staticClass: "right-overview-cards" }, [
                  _c("div", { staticClass: "small-card" }, [
                    _c("div", { staticClass: "card-text" }, [
                      _c("span", { staticClass: "bold-text" }, [
                        _c("i", {
                          staticClass: "icon-shebei icon",
                          staticStyle: {
                            color: "#e6a23c",
                            "font-size": "20px",
                            "margin-right": "5px",
                          },
                        }),
                        _vm._v(" 设备总数"),
                      ]),
                      _vm._v("（单位：台） "),
                    ]),
                    _c("div", { staticClass: "card-value" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.HomepageStatisticsInfo.DeviceCount || 0) +
                          " "
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "small-card" }, [
                    _c("div", { staticClass: "card-text" }, [
                      _c("span", { staticClass: "bold-text" }, [
                        _c("i", {
                          staticClass: "icon-yunhangzhong icon",
                          staticStyle: {
                            color: "#67c23a",
                            "font-size": "20px",
                            "margin-right": "5px",
                          },
                        }),
                        _vm._v("开机中"),
                      ]),
                      _vm._v("（单位：台） "),
                    ]),
                    _c("div", { staticClass: "card-value" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.HomepageStatisticsInfo.PowerOn || 0) +
                          " "
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "small-card" }, [
                    _c("div", { staticClass: "card-text" }, [
                      _c("span", { staticClass: "bold-text" }, [
                        _c("i", {
                          staticClass: "icon-tingzhizhong1 icon",
                          staticStyle: {
                            color: "#f56c6c",
                            "font-size": "20px",
                            "margin-right": "5px",
                          },
                        }),
                        _vm._v("停机中"),
                      ]),
                      _vm._v("（单位：台） "),
                    ]),
                    _c("div", { staticClass: "card-value" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.HomepageStatisticsInfo.PowerOff || 0) +
                          " "
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "small-card" }, [
                    _c("div", { staticClass: "card-text" }, [
                      _c("span", { staticClass: "bold-text" }, [
                        _c("i", {
                          staticClass: "icon-tingzhizhong icon",
                          staticStyle: {
                            color: "#e6a23c",
                            "font-size": "20px",
                            "margin-right": "5px",
                          },
                        }),
                        _vm._v("故障中"),
                      ]),
                      _vm._v("（单位：台） "),
                    ]),
                    _c("div", { staticClass: "card-value" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.HomepageStatisticsInfo.FaultNum || 0) +
                          " "
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "small-card" }, [
                    _c("div", { staticClass: "card-text" }, [
                      _c("img", {
                        staticStyle: {
                          width: "20px",
                          height: "20px",
                          "margin-right": "10px",
                        },
                        attrs: { src: require("@/assets/shui.png"), alt: "" },
                      }),
                      _c("span", { staticClass: "bold-text" }, [
                        _vm._v("水耗"),
                      ]),
                      _vm._v(" （单位：元） "),
                    ]),
                    _c("div", { staticClass: "card-value" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$tools.formatThousand(
                              _vm.HomepageStatisticsInfo.Water,
                              2
                            )
                          ) +
                          " "
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "small-card" }, [
                    _c("div", { staticClass: "card-text" }, [
                      _c("img", {
                        staticStyle: {
                          width: "20px",
                          height: "20px",
                          "margin-right": "10px",
                        },
                        attrs: { src: require("@/assets/dian.png"), alt: "" },
                      }),
                      _c("span", { staticClass: "bold-text" }, [
                        _vm._v("电耗"),
                      ]),
                      _vm._v(" （单位：元） "),
                    ]),
                    _c("div", { staticClass: "card-value" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$tools.formatThousand(
                              _vm.HomepageStatisticsInfo.Electricity,
                              2
                            )
                          ) +
                          " "
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "small-card" }, [
                    _c("div", { staticClass: "card-text" }, [
                      _c("img", {
                        staticStyle: {
                          width: "20px",
                          height: "20px",
                          "margin-right": "10px",
                        },
                        attrs: { src: require("@/assets/qi.png"), alt: "" },
                      }),
                      _c("span", { staticClass: "bold-text" }, [
                        _vm._v("气耗"),
                      ]),
                      _vm._v(" （单位：元） "),
                    ]),
                    _c("div", { staticClass: "card-value" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$tools.formatThousand(
                              _vm.HomepageStatisticsInfo.Gas,
                              2
                            )
                          ) +
                          " "
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "small-card" }, [
                    _c("div", { staticClass: "card-text" }, [
                      _c("img", {
                        staticStyle: {
                          width: "20px",
                          height: "20px",
                          "margin-right": "10px",
                        },
                        attrs: { src: require("@/assets/you.png"), alt: "" },
                      }),
                      _c("span", { staticClass: "bold-text" }, [
                        _vm._v("油耗"),
                      ]),
                      _vm._v(" （单位：元） "),
                    ]),
                    _c("div", { staticClass: "card-value" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$tools.formatThousand(
                              _vm.HomepageStatisticsInfo.Oil,
                              2
                            )
                          ) +
                          " "
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
          _c(
            "el-card",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.CompletePeriodLoading,
                  expression: "CompletePeriodLoading",
                },
              ],
              staticClass: "section-card inspection-maintenance",
            },
            [
              _c("div", { staticClass: "section-title df aic jub" }, [
                _c("span", [_vm._v("全周期成本")]),
                _c("span", { staticClass: "hint-text" }, [
                  _vm._v(
                    " 全周期成本（累计值） =（原值+维保+备件+能耗） 单位：（元） "
                  ),
                ]),
              ]),
              _c("EchartsDom", {
                attrs: {
                  type: "bar2",
                  data: _vm.CompletePeriodInfo || [],
                  "is-stack": true,
                  barWidth: "40%",
                  legendTop: "5px",
                  thousandSeparator: true,
                  grid: {
                    left: 120,
                    right: 40,
                    bottom: 20,
                    top: 40,
                  },
                  width: "100%",
                  height: "200px",
                },
              }),
            ],
            1
          ),
          _c(
            "el-card",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.HomepageRunLoading,
                  expression: "HomepageRunLoading",
                },
              ],
              staticClass: "section-card operational-status",
            },
            [
              _c("div", { staticClass: "section-title" }, [
                _vm._v("故障分析(最近12个月)"),
              ]),
              _c(
                "div",
                {
                  staticClass: "status-content",
                  staticStyle: { position: "relative" },
                },
                [
                  _c("EchartsDom", {
                    attrs: {
                      type: "bar2",
                      data: _vm.yearChartsInfo.yearFaultObjList || [],
                      title: "故障分析",
                      grid: {
                        left: 60,
                        top: 65,
                        right: 40,
                        bottom: 20,
                      },
                      legendTop: "30px",
                      width: "60%",
                      height: "100%",
                      legendType: "scroll",
                      labelPosition: "inside",
                    },
                  }),
                  _c("el-divider", {
                    staticClass: "divider",
                    attrs: { direction: "vertical" },
                  }),
                  _vm.radio1 === "1"
                    ? _c("EchartsDom", {
                        attrs: {
                          type: "pie",
                          data: _vm.yearChartsInfo.faultobjlist || [],
                          title: "故障分类",
                          width: "40%",
                          height: "100%",
                          legendType: "scroll",
                          legendPosition: "left",
                          legendLeft: "10px",
                        },
                      })
                    : _vm._e(),
                  _vm.radio1 === "2"
                    ? _c("EchartsDom", {
                        attrs: {
                          type: "pie",
                          data: _vm.yearChartsInfo.devicetypeobjlist || [],
                          title: "设备分类",
                          width: "40%",
                          height: "100%",
                          legendPosition: "left",
                          legendLeft: "10px",
                        },
                      })
                    : _vm._e(),
                  _c(
                    "el-radio-group",
                    {
                      staticStyle: {
                        position: "absolute",
                        right: "0",
                        top: "0",
                      },
                      model: {
                        value: _vm.radio1,
                        callback: function ($$v) {
                          _vm.radio1 = $$v
                        },
                        expression: "radio1",
                      },
                    },
                    [
                      _c("el-radio-button", { attrs: { label: "1" } }, [
                        _vm._v("故障分类"),
                      ]),
                      _c("el-radio-button", { attrs: { label: "2" } }, [
                        _vm._v("设备分类"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-card",
            { staticClass: "section-card inspection-maintenance" },
            [
              _c(
                "div",
                { staticClass: "section-title" },
                [
                  _c("span", [_vm._v("运维情况")]),
                  _c(
                    "el-radio-group",
                    {
                      staticStyle: { "margin-left": "20px" },
                      on: { change: _vm.dayChange },
                      model: {
                        value: _vm.day,
                        callback: function ($$v) {
                          _vm.day = $$v
                        },
                        expression: "day",
                      },
                    },
                    [
                      _c("el-radio-button", { attrs: { label: "10" } }, [
                        _vm._v("近10天"),
                      ]),
                      _c("el-radio-button", { attrs: { label: "20" } }, [
                        _vm._v("近20天"),
                      ]),
                      _c("el-radio-button", { attrs: { label: "30" } }, [
                        _vm._v("近30天"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.WorkOrderLoading,
                      expression: "WorkOrderLoading",
                    },
                  ],
                  staticClass: "WorkOrder-card",
                },
                [
                  _c("div", { staticClass: "right-overview-cards" }, [
                    _c("div", { staticClass: "small-card" }, [
                      _c("div", { staticClass: "card-text" }, [
                        _vm._v("工单量"),
                      ]),
                      _c("div", { staticClass: "card-value" }, [
                        _vm._v(
                          " " + _vm._s(_vm.WorkOrderInfo.total || 0) + " "
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "small-card" }, [
                      _c("div", { staticClass: "card-text" }, [
                        _vm._v("完成率"),
                      ]),
                      _c("div", { staticClass: "card-value" }, [
                        _vm._v(_vm._s(_vm.WorkOrderInfo.rate || 0) + "%"),
                      ]),
                    ]),
                    _c("div", { staticClass: "small-card" }, [
                      _c("div", { staticClass: "card-text" }, [
                        _vm._v("平均完成时长（小时）"),
                      ]),
                      _c("div", { staticClass: "card-value" }, [
                        _vm._v(" " + _vm._s(_vm.WorkOrderInfo.avg || 0) + " "),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _c(
                "el-tabs",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { type: "card" },
                  on: { "tab-click": _vm.handleTabClick },
                  model: {
                    value: _vm.cardActiveName,
                    callback: function ($$v) {
                      _vm.cardActiveName = $$v
                    },
                    expression: "cardActiveName",
                  },
                },
                [
                  _c("el-tab-pane", { attrs: { label: "巡检", name: "巡检" } }),
                  _c("el-tab-pane", { attrs: { label: "保养", name: "保养" } }),
                  _c("el-tab-pane", { attrs: { label: "维修", name: "维修" } }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "w100 df aic" },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "calc(100%)",
                        "text-align": "center",
                        "font-size": "18px",
                        "font-weight": "bold",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.activeNameTitle[0] || "") + " ")]
                  ),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "请选择" },
                      on: { change: _vm.getHomepageInspectionAndMaintenance },
                      model: {
                        value: _vm.activeName,
                        callback: function ($$v) {
                          _vm.activeName = $$v
                        },
                        expression: "activeName",
                      },
                    },
                    [
                      _vm.cardActiveName === "巡检"
                        ? _c("el-option", {
                            attrs: { label: "巡检次数", value: "4" },
                          })
                        : _vm._e(),
                      _vm.cardActiveName === "巡检"
                        ? _c("el-option", {
                            attrs: { label: "各专业巡检频次", value: "2" },
                          })
                        : _vm._e(),
                      _vm.cardActiveName === "巡检"
                        ? _c("el-option", {
                            attrs: { label: "各类型巡检频次", value: "3" },
                          })
                        : _vm._e(),
                      _vm.cardActiveName === "保养"
                        ? _c("el-option", {
                            attrs: { label: "各专业保养频次", value: "5" },
                          })
                        : _vm._e(),
                      _vm.cardActiveName === "保养"
                        ? _c("el-option", {
                            attrs: { label: "各类型保养频次", value: "6" },
                          })
                        : _vm._e(),
                      _vm.cardActiveName === "维修"
                        ? _c("el-option", {
                            attrs: { label: "各专业维修频次", value: "7" },
                          })
                        : _vm._e(),
                      _vm.cardActiveName === "维修"
                        ? _c("el-option", {
                            attrs: { label: "各类型维修频次", value: "8" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("EchartsDom", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.HomepageInspectionAndMaintenanceLoading,
                    expression: "HomepageInspectionAndMaintenanceLoading",
                  },
                ],
                attrs: {
                  type: "bar",
                  data: _vm.WorkOrderDataInfo || [],
                  width: "100%",
                  grid: {
                    left: 60,
                    top: 30,
                    right: 40,
                    bottom: 20,
                  },
                  height: "180px",
                  legendType: "scroll",
                  yAxisName: _vm.activeNameTitle[1] || "",
                  labelPosition: "inside",
                },
              }),
            ],
            1
          ),
          _c(
            "el-card",
            { staticClass: "section-card inspection-maintenance" },
            [
              _c("div", { staticClass: "section-title df jub" }, [
                _c(
                  "span",
                  [
                    _c("span", [_vm._v("备件库存")]),
                    _c(
                      "el-radio-group",
                      {
                        staticStyle: {
                          "margin-left": "20px",
                          "font-size": "12px",
                        },
                        on: { change: _vm.MaterialInventoryInTypeChange },
                        model: {
                          value: _vm.MaterialInventoryInType,
                          callback: function ($$v) {
                            _vm.MaterialInventoryInType = $$v
                          },
                          expression: "MaterialInventoryInType",
                        },
                      },
                      [
                        _c("el-radio-button", { attrs: { label: "Amount" } }, [
                          _c("i", {
                            staticClass: "icon icon-rmb1",
                            staticStyle: { "font-size": "14px" },
                          }),
                          _vm._v(" 金额"),
                        ]),
                        _c("el-radio-button", { attrs: { label: "Qty" } }, [
                          _c("i", {
                            staticClass: "icon icon-num",
                            staticStyle: { "font-size": "14px" },
                          }),
                          _vm._v(" 数量"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.WorkOrderLoading,
                      expression: "WorkOrderLoading",
                    },
                  ],
                  staticClass: "WorkOrder-card",
                },
                [
                  _c("div", { staticClass: "right-overview-cards" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.MaterialInventoryInLoading,
                            expression: "MaterialInventoryInLoading",
                          },
                        ],
                        staticClass: "small-card",
                      },
                      [
                        _c("div", { staticClass: "card-text" }, [
                          _c("span", { staticClass: "bold-text" }, [
                            _vm._v("当前库存"),
                          ]),
                          _vm.MaterialInventoryInType === "Amount"
                            ? _c("span", [_vm._v("（单位：元）")])
                            : _vm._e(),
                          _vm.MaterialInventoryInType === "Qty"
                            ? _c("span", [_vm._v("（单位：件）")])
                            : _vm._e(),
                        ]),
                        _c("div", { staticClass: "card-value" }, [
                          _vm.MaterialInventoryInType === "Qty"
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$tools.formatThousand(
                                      _vm.MaterialInventoryInInfo.tNum,
                                      0
                                    ) || 0
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm.MaterialInventoryInType === "Amount"
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$tools.formatThousand(
                                      _vm.MaterialInventoryInInfo.tAmount,
                                      2
                                    ) || 0
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.MaterialInventoryInPutLoading,
                            expression: "MaterialInventoryInPutLoading",
                          },
                        ],
                        staticClass: "small-card",
                      },
                      [
                        _c("div", { staticClass: "card-text" }, [
                          _c("span", { staticClass: "bold-text" }, [
                            _vm._v("累计入库(最近12个月)"),
                          ]),
                          _vm.MaterialInventoryInType === "Amount"
                            ? _c("span", [_vm._v("（单位：元）")])
                            : _vm._e(),
                          _vm.MaterialInventoryInType === "Qty"
                            ? _c("span", [_vm._v("（单位：件）")])
                            : _vm._e(),
                        ]),
                        _c("div", { staticClass: "card-value" }, [
                          _vm.MaterialInventoryInType === "Qty"
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$tools.formatThousand(
                                      _vm.MaterialInventoryInInfoPut.tNum,
                                      0
                                    ) || 0
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm.MaterialInventoryInType === "Amount"
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$tools.formatThousand(
                                      _vm.MaterialInventoryInInfoPut.tAmount,
                                      2
                                    ) || 0
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.MaterialInventoryInOutLoading,
                            expression: "MaterialInventoryInOutLoading",
                          },
                        ],
                        staticClass: "small-card",
                      },
                      [
                        _c("div", { staticClass: "card-text" }, [
                          _c("span", { staticClass: "bold-text" }, [
                            _vm._v("累计出库(最近12个月)"),
                          ]),
                          _vm.MaterialInventoryInType === "Amount"
                            ? _c("span", [_vm._v("（单位：元）")])
                            : _vm._e(),
                          _vm.MaterialInventoryInType === "Qty"
                            ? _c("span", [_vm._v("（单位：件）")])
                            : _vm._e(),
                        ]),
                        _c("div", { staticClass: "card-value" }, [
                          _vm.MaterialInventoryInType === "Qty"
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$tools.formatThousand(
                                      _vm.MaterialInventoryInInfoOut.tNum,
                                      0
                                    ) || 0
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm.MaterialInventoryInType === "Amount"
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$tools.formatThousand(
                                      _vm.MaterialInventoryInInfoOut.tAmount,
                                      2
                                    ) || 0
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.WorkOrderLoading,
                      expression: "WorkOrderLoading",
                    },
                  ],
                  staticClass: "WorkOrder-card",
                },
                [
                  _c("div", { staticClass: "right-overview-cards" }, [
                    _c(
                      "div",
                      {
                        staticClass: "df",
                        staticStyle: {
                          width: "100%",
                          position: "relative",
                          height: "220px",
                        },
                      },
                      [
                        _c("EchartsDom", {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.MaterialInventoryInLoading,
                              expression: "MaterialInventoryInLoading",
                            },
                          ],
                          staticStyle: {
                            width: "100%",
                            height: "220px",
                            "margin-top": "20px",
                          },
                          attrs: {
                            type: "pie",
                            data: _vm.MaterialInventoryInInfo.blist || [],
                            legendPosition: "bottom",
                            title: "库存分布",
                            showLegend: false,
                            thousandSeparator: true,
                            decimalPlaces:
                              _vm.MaterialInventoryInType === "Qty" ? 0 : 2,
                          },
                        }),
                        _c("el-divider", {
                          staticClass: "divider ec",
                          attrs: { direction: "vertical" },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "df",
                        staticStyle: {
                          width: "100%",
                          position: "relative",
                          height: "220px",
                        },
                      },
                      [
                        _c("EchartsDom", {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.MaterialInventoryInPutLoading,
                              expression: "MaterialInventoryInPutLoading",
                            },
                          ],
                          staticStyle: {
                            width: "100%",
                            height: "220px",
                            "margin-top": "20px",
                          },
                          attrs: {
                            type: "pie",
                            data: _vm.MaterialInventoryInInfoPut.blist || [],
                            legendPosition: "bottom",
                            title: "入库分布",
                            showLegend: false,
                            thousandSeparator: true,
                            decimalPlaces:
                              _vm.MaterialInventoryInType === "Qty" ? 0 : 2,
                          },
                        }),
                        _c("el-divider", {
                          staticClass: "divider ec",
                          attrs: { direction: "vertical" },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "df",
                        staticStyle: {
                          width: "100%",
                          position: "relative",
                          height: "220px",
                        },
                      },
                      [
                        _c("EchartsDom", {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.MaterialInventoryInOutLoading,
                              expression: "MaterialInventoryInOutLoading",
                            },
                          ],
                          staticStyle: {
                            width: "100%",
                            height: "220px",
                            "margin-top": "20px",
                          },
                          attrs: {
                            type: "pie",
                            data: _vm.MaterialInventoryInInfoOut.blist || [],
                            legendPosition: "bottom",
                            title: "出库分布",
                            thousandSeparator: true,
                            decimalPlaces:
                              _vm.MaterialInventoryInType === "Qty" ? 0 : 2,
                            showLegend: false,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ]
          ),
          _c(
            "el-card",
            { staticClass: "section-card inspection-maintenance" },
            [
              _c(
                "div",
                { staticClass: "section-title" },
                [
                  _c("span", [_vm._v("能耗信息（最近12个月）")]),
                  _c(
                    "el-radio-group",
                    {
                      staticStyle: { "margin-left": "20px" },
                      on: { change: _vm.getEnergycInfo },
                      model: {
                        value: _vm.EnergycType,
                        callback: function ($$v) {
                          _vm.EnergycType = $$v
                        },
                        expression: "EnergycType",
                      },
                    },
                    [
                      _c("el-radio-button", { attrs: { label: "Amount" } }, [
                        _c("i", {
                          staticClass: "icon icon-rmb1",
                          staticStyle: { "font-size": "14px" },
                        }),
                        _vm._v(" 金额"),
                      ]),
                      _c("el-radio-button", { attrs: { label: "Qty" } }, [
                        _c("i", {
                          staticClass: "icon icon-num",
                          staticStyle: { "font-size": "14px" },
                        }),
                        _vm._v(" 耗用量"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.EnergycLoading,
                      expression: "EnergycLoading",
                    },
                  ],
                  staticClass: "WorkOrder-card",
                },
                [
                  _c(
                    "div",
                    { staticClass: "right-overview-cards4" },
                    _vm._l(_vm.EnergycInfo?.list, function (item) {
                      return _c(
                        "div",
                        { key: item.Name, staticClass: "small-card" },
                        [
                          _c("div", { staticClass: "card-text" }, [
                            _c("img", {
                              staticStyle: {
                                width: "20px",
                                height: "20px",
                                "margin-right": "10px",
                              },
                              attrs: {
                                src:
                                  item.name === "水"
                                    ? require("@/assets/shui.png")
                                    : item.name === "电"
                                    ? require("@/assets/dian.png")
                                    : item.name === "气"
                                    ? require("@/assets/qi.png")
                                    : item.name === "油"
                                    ? require("@/assets/you.png")
                                    : "",
                                alt: "",
                              },
                            }),
                            _c("span", { staticClass: "bold-text" }, [
                              _vm._v(_vm._s(item.name) + "耗 "),
                            ]),
                            _vm._v(
                              " （单位：" +
                                _vm._s(
                                  _vm.EnergycType === "Qty"
                                    ? item.name === "水"
                                      ? "方"
                                      : item.name === "电"
                                      ? "度"
                                      : item.name === "气"
                                      ? "方"
                                      : "升"
                                    : "元"
                                ) +
                                "） "
                            ),
                          ]),
                          _c("div", { staticClass: "card-value" }, [
                            _vm.EnergycType === "Qty"
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$tools.formatThousand(
                                        item.value.Qty,
                                        0
                                      ) || 0
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm.EnergycType === "Amount"
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$tools.formatThousand(
                                        item.value.Amount || 0,
                                        2
                                      )
                                    )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.EnergycLoading,
                      expression: "EnergycLoading",
                    },
                  ],
                  staticClass: "WorkOrder-card",
                },
                [
                  _c(
                    "div",
                    { staticClass: "right-overview-cards4" },
                    _vm._l(_vm.EnergycInfo?.blist, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: item.name,
                          staticClass: "df",
                          staticStyle: { width: "100%", position: "relative" },
                        },
                        [
                          _c("EchartsDom", {
                            staticStyle: {
                              width: "100%",
                              height: "220px",
                              "margin-top": "20px",
                            },
                            attrs: {
                              type: "pie",
                              data: item.value || [],
                              thousandSeparator: true,
                              decimalPlaces: _vm.EnergycType === "Qty" ? 0 : 2,
                              legendPosition: "bottom",
                              title: item.name + "耗分布",
                              showLegend: false,
                            },
                          }),
                          index !== _vm.EnergycInfo?.blist?.length - 1
                            ? _c("el-divider", {
                                staticClass: "divider ec",
                                attrs: { direction: "vertical" },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]
              ),
            ]
          ),
          _c("div", { staticStyle: { height: "50px" } }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "right-panel" },
        [
          _c(
            "div",
            {
              staticClass: "section-card cost-overview",
              staticStyle: {
                height: "270px",
                padding: "0",
                position: "relative",
              },
            },
            [
              _c("div", { staticClass: "projectInfo" }, [
                _c(
                  "div",
                  { staticClass: "ellipsis2", staticStyle: { flex: "1" } },
                  [_vm._v(_vm._s(_vm.ProjectInfo.Name || ""))]
                ),
                _c(
                  "div",
                  { staticClass: "ellipsis2", staticStyle: { flex: "1" } },
                  [
                    _vm._v(
                      " 建筑面积：" +
                        _vm._s(_vm.ProjectInfo.TotalArea || "") +
                        "㎡ "
                    ),
                  ]
                ),
              ]),
              _c("el-image", {
                key: _vm.ProjectInfo.ProjectImg,
                staticStyle: {
                  width: "100%",
                  height: "calc(100% - 40px)",
                  "border-radius": "8px",
                },
                attrs: { src: _vm.ProjectInfo.ProjectImg || "", fit: "cover" },
                on: { error: _vm.handleImageError },
              }),
            ],
            1
          ),
          _c(
            "el-card",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.HomepageStatisticsLoading,
                  expression: "HomepageStatisticsLoading",
                },
              ],
              staticClass: "section-card operational-status",
            },
            [
              _c("div", { staticClass: "section-title df jub" }, [
                _c("span", [_vm._v("设备开停机状态（实时更新-最新）")]),
                _c("span", { staticClass: "hint-text" }, [
                  _vm._v("单位：（台）"),
                ]),
              ]),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%", "min-height": "240px" },
                  attrs: {
                    data: _vm.HomepageStatisticsInfo.list,
                    stripe: "",
                    "header-row-class-name": "table-tit",
                    "row-class-name": "table-row",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "楼栋", prop: "BuildingName" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "开机数（台）",
                      prop: "oNum",
                      align: "right",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "停机数（台）",
                      prop: "sNum",
                      align: "right",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-card",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.HomepageStatisticsLoading,
                  expression: "HomepageStatisticsLoading",
                },
              ],
              staticClass: "section-card operational-status",
            },
            [
              _c("div", { staticClass: "section-title df jub" }, [
                _c("span", [_vm._v("设备故障状态（实时更新-最新）")]),
                _c("span", { staticClass: "hint-text" }, [
                  _vm._v("单位：（台）"),
                ]),
              ]),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%", "min-height": "240px" },
                  attrs: {
                    data: _vm.HomepageStatisticsInfo.falist,
                    stripe: "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "楼栋", prop: "BuildingName" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "故障数（台）",
                      prop: "oNum",
                      align: "right",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "故障时长（小时）",
                      prop: "sNum",
                      align: "right",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "section-card cost-overview" }, [
            _vm._m(0),
            _c("div", { staticClass: "cost-details" }, [
              _c("div", { staticClass: "sales-yoy" }, [
                _c("div", { staticClass: "item" }, [
                  _c("div", { staticClass: "label" }, [_vm._v("能耗成本")]),
                  _c("div", { staticClass: "value" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$tools.formatThousand(
                            _vm.HomepageCostInfo.TconsumptionCost,
                            2
                          )
                        ) +
                        " "
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "item" }, [
                  _c("div", { staticClass: "label" }, [_vm._v("保养成本")]),
                  _c("div", { staticClass: "value" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$tools.formatThousand(
                            _vm.HomepageCostInfo.OperationCost,
                            2
                          )
                        ) +
                        " "
                    ),
                  ]),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "category-list" },
                [
                  _vm._l(
                    _vm.HomepageCostInfo.devicetypecost,
                    function (item, index) {
                      return _c(
                        "div",
                        { key: item.Name, staticClass: "category-item" },
                        [
                          _c("div", { staticClass: "rank" }, [
                            _vm._v(_vm._s(index + 1)),
                          ]),
                          _c("div", { staticClass: "name" }, [
                            _vm._v(_vm._s(item.Name)),
                          ]),
                          _c("div", { staticClass: "progress-container" }, [
                            _c("div", {
                              staticClass: "progress-bar",
                              style: {
                                width:
                                  (item.Amout /
                                    _vm.HomepageCostInfo.devicetypecost[0]
                                      ?.Amout) *
                                    100 +
                                  "%",
                              },
                            }),
                          ]),
                          _c("div", { staticClass: "value" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$tools.formatThousand(item.Amout, 2)
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      )
                    }
                  ),
                  _c("div", { staticStyle: { height: "13px" } }),
                ],
                2
              ),
            ]),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section-title df jub" }, [
      _c("span", [_vm._v("成本总览（最近12个月）")]),
      _c("span", { staticClass: "hint-text" }, [_vm._v("单位：（元）")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }